<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
    />
    <path d="M9 12l2 2 4-4" />
  </svg>
</template>

<script>
export default {
  name: 'IconCheckCircle',
  props: {
    size: { type: [String, Number], default: 20 },
    strokeWidth: { type: [String, Number], default: 2 },
  },
};
</script>
